/* eslint-disable react/prop-types */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import {
  Avatar,
  Card,
  CardContent,
  Typography,
  Paper,
  Select,
  MenuItem,
  InputLabel,
  TextField,
  Button,
  Tooltip,
  Grid,
  Switch,
  createStyles,
  Hidden,
  FormControl,
  FormLabel,
} from '@material-ui/core';
import 'react-virtualized/styles.css';
import { ToggleButtonGroup } from '@material-ui/lab';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { FormatListBulleted, Autorenew } from '@material-ui/icons';
import TimeAgo from 'react-timeago';
import moment from 'moment';
import 'moment-timezone';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import * as groupsListingsActtions from '../../../redux/actions/groups-listings';
import store from '../../../redux/store';
import { usePricing } from '../../../context/pricing-context';
import { saveEventLink, forceRefresh } from '../../../services/killshot';
import { ReactComponent as EditIcon } from '../../../images/edit.svg';
import useWindowSize from '../../../hooks/useWindowsSize';
import ListingsTable from './Table';
import { MARKETPLACE_LABELS, GROUP_CRITERIA_SPLITS } from '../../../helpers/constants';
import ValidateUser from '../../../components/UserStatus';
import { SplitStyledToggleButton, NormalStyledDarkToggleButton } from '../../../components/Common/ToggleButton';

const pxToRem = (px, oneRemPx = 17) => `${px / oneRemPx}rem`;
const borderWidth = 2;
const widthRoot = pxToRem(44);
const heightRoot = pxToRem(26);
const size = pxToRem(20);
const gap = (40 - 32) / 2;
const primaryColor = '#9C27B0';
const splitsDefault = ['All'];

const getCanonicalName = (section_name, zones) => {
  const canonicals = [];
  if (zones) {
    for (const zone of zones) {
      for (const section of zone.sections) {
        if (section_name === section.name) {
          canonicals.push(section.canonical_name);
        }
      }
      if (canonicals.length > 0) {
        return canonicals;
      }
    }
  }
  return canonicals;
};
const useSwitchStyles = makeStyles(() =>
  createStyles({
    root: {
      width: widthRoot,
      height: heightRoot,
      padding: 0,
      overflow: 'unset',
    },
    switchBase: {
      padding: pxToRem(gap),
      '&$checked': {
        color: '#fff',
        transform: `translateX(calc(${widthRoot} - ${size} - ${pxToRem(2 * gap)}))`,
        '& + $track': {
          opacity: 1,
          backgroundColor: primaryColor,
        },
        '& $thumb': {
          backgroundColor: '#fff',
          backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="14" viewBox="0 0 24 24" width="14"><path d="M0 0h24v24H0z" fill="none"/><path fill="${encodeURIComponent(
            primaryColor
          )}" d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg>')`,
        },
      },
    },
    track: {
      borderRadius: 40,
      backgroundColor: '#E4E6EA',
      border: 'none',
      opacity: 1,
      borderWidth,
    },
    thumb: {
      width: size,
      height: size,
      boxShadow: 'none',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="12" viewBox="0 0 24 24" width="12"><path fill="${encodeURIComponent(
        '#9CA3AF'
      )}" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>')`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    },
    checked: {},
  })
);

const styles = makeStyles(() => ({
  pricingSection: {
    marginTop: '8px',
    flexGrow: 1,
    flexBasis: 'auto',
  },
  cardContentRoot: {
    padding: '0 10px 10px 10px',
    paddingBottom: '60px !important',
    height: '96%',
  },
  pricingLoadingModalContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  subTitle: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '21px',
    color: '#00000',
    marginBottom: 19,
  },
  eventUrlDescription: {
    fontSize: 14,
    lineHeight: '19px',
    color: '#00000',
    marginBottom: 27,
  },
  eventUrlButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 40,
  },
  infoListingsContainer: {
    padding: '5px',
  },
  subInfoMarketplaceContainer: {
    display: 'flex',
    padding: '0px 15px 10px 11px',
    alignItems: 'center',
  },
  splitsContainer: {
    display: 'flex',
    padding: '0px 15px 10px 15px',
    alignItems: 'center',
    marginTop: '-10px',
  },
  compAllContainer: {
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  listingsContainer: {
    justifyContent: 'flex-start',
  },
  compAllLabel: {
    fontSize: '12px',
    marginLeft: '5px',
  },
  marketplaceContainerDark: {
    padding: '15px',
    backgroundColor: '#2D3436',
  },
  marketplaceContainerLight: {
    padding: '15px',
    backgroundColor: '#F4F4F4',
  },
  lastUpdateLabelDark: {
    fontSize: '12px',
    color: '#BEBEBE',
    marginLeft: '10px',
  },
  lastUpdateLabelLight: {
    fontSize: '12px',
    color: '#3C3C3C',
    marginLeft: '5px',
  },
  lastUpdatedMedium: {
    display: 'flex',
    alignItems: 'center',
  },
  lastUpdatedNormal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  tooltipLabel: {
    fontSize: '22px',
  },
  OursTempLabelDark: {
    fontSize: '11px',
    color: '#FF6C6C',
  },
  OursTempLabelLight: {
    fontSize: '11px',
    color: '#D20000',
  },
  splitButton: {
    minWidth: '35px !important',
    width: '35px !important',
    height: '35px !important',
    fontSize: '13px !important',
    textTransform: 'none',
    fontWeight: '400 !important',
    '& .MuiToggleButton-root': {
      textTransform: 'none',
    },
  },
  italicLabel: {
    fontStyle: 'italic',
  },
  inventoryTabsWrap: {
    height: '100%',
  },
  tableHeader: {
    backgroundColor: '#f1f1f1',
    color: '#333',
    fontWeight: 'bold',
    textTransform: 'none !important',
  },
  tableCell: {
    color: '#333',
  },
  tableAlternateRow: {
    backgroundColor: '#f9f9f9',
  },
  virtualizedTable: {
    fontSize: '12px',
    width: '100%',
    height: '95%',
  },
}));

const SaveEventURLContainer = styled.div`
  width: 100%;
  padding: 23px 23px 37px 23px;
  border: 1px solid #bdc3c7;
  box-sizing: border-box;
  box-shadow: 0px 2px 5px 1px rgba(112, 113, 113, 0.5);
`;

const CircleIcon = styled.div`
  width: 22px;
  height: 22px;
  padding: 5px;
  border-radius: 50%;
  background: #9c27b0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const DEBOUNCE_DELAY = 50;

const listingsSelector = (listings, activeMarketplace) =>
  listings.map(l => ({
    quantity: l.quantity,
    zone: l.zone_name,
    section: l.section_name,
    section_canonical: l.canonical_name,
    row: l.row,
    is_obstructed: l.is_obstructed,
    splits: l.split_vector.join(', '),
    split_vector: l.split_vector,
    total_price: l.face_value.toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
    is_ours: l.is_ours,
    org_id: l.org_id,
    original_price: l.original_price,
    ...(activeMarketplace === 'seatgeek' && { deal_score: l.deal_score }),
    ...(activeMarketplace === 'seatgeek' && l.all_in_price
      ? {
          all_in_price: l.all_in_price.toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        }
      : { all_in_price: '' }),
  }));

const Listings = props => {
  const {
    actions,
    activeMarketplace,
    compsLoading,
    currTNCompSections,
    eventInfo,
    eventMeta,
    focusedPricingGroup,
    handleGroupAttrEdit,
    isCompAllEvent,
    isCompAllGroup,
    marketsData,
    selectedGroupSplits,
    setCompAllChange,
    setRefresh,
    tabSelected,
    zones,
  } = props;

  const timeoutRef = useRef(null);

  const classes = styles();
  const theme = useTheme();

  const switchTheme = useSwitchStyles();
  const windowsSize = useWindowSize();

  // This function does not exists. It is a bug on production. It should be defined the expected behaviour by product
  // and implement the function
  const { fetchData } = usePricing();

  const [desiredSgListingCount, setDesiredSgListingCount] = useState(null);
  const [totalTickets, setTotalTickets] = useState(0);
  const [totalListings, setTotalListings] = useState(0);
  const [eventUrlError, setEventUrlError] = useState('');
  const [filteredListings, setFilteredListings] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [marketplaceURL, setMarketplaceUrl] = useState('');
  const [originalListings, setOriginalListings] = useState([]);
  const [realSgListingCount, setRealSgListingCount] = useState(null);
  const [splits, setSplits] = useState(splitsDefault);
  const [timerInfo, setTimerInfo] = useState(eventInfo?.last_updated);

  const marketplaceName = tabSelected === 0 ? 'ticketnetwork' : 'seatgeek';
  const title = tabSelected === 0 ? ' TicketNetwork ' : ' SeatGeek ';
  let marketURL;
  if (title === ' TicketNetwork ') {
    marketURL = `https://www.ticketnetwork.com/tickets/${eventMeta.ticketnetwork_id}`;
  } else {
    marketURL = eventMeta.seatgeek_event_url;
  }
  const currentTimerInfo = tabSelected === 0 ? timerInfo?.ticketnetwork : timerInfo?.seatgeek;
  const updatedTimes = [
    currentTimerInfo
      ? moment
          .utc(currentTimerInfo)
          .local()
          .format('YYYY-MM-DD HH:mm:ss')
      : null,
  ];

  const activeMarketData = marketType => {
    if (marketsData && Array.isArray(marketsData) && marketsData.length > 0) {
      return marketsData.find(d => d?.response?.market === marketType);
    }
    return [];
  };

  const isRowValid = (row, lowRow, highRow, zoneType) => {
    if (zoneType === 'Single letters' && /^[A-Z]$/.test(row)) {
      return row >= 'A' && row <= 'Z' && row.length === 1 && row >= lowRow && row <= highRow;
    }

    if (zoneType === 'Double letters' && /^[A-Z]{2}$/.test(row)) {
      return row >= 'AA' && row <= 'ZZ' && row.length === 2 && row >= lowRow && row <= highRow;
    }

    if (zoneType === 'Triple letters' && /^[A-Z]{3}$/.test(row)) {
      return row >= 'AAA' && row <= 'ZZZ' && row.length === 3 && row >= lowRow && row <= highRow;
    }

    if (zoneType === 'Numbers' && !isNaN(row)) {
      const newRow = Number.parseInt(row, 10);
      const newLowRow = isNaN(lowRow) ? 0 : Number.parseInt(lowRow, 10);
      const newHighRow = isNaN(highRow) ? Number.MAX_SAFE_INTEGER : Number.parseInt(highRow, 10);
      return newRow >= newLowRow && row <= newHighRow;
    }

    return false;
  };

  const calculatePaddingBottomListings = () => {
    if (windowsSize.width >= 1280 && windowsSize.width < 1600) {
      return '180px';
    }
    return '140px';
  };

  const filterListings = isCompAll => {
    const marketData = activeMarketData(activeMarketplace);
    if (marketData !== null) {
      setDesiredSgListingCount(marketData?.response?.desired_broadcasted_count);
      setRealSgListingCount(marketData?.response?.real_broadcasted_count);
      const selectorListings = listingsSelector(marketData?.response?.listings ?? [], activeMarketplace);
      setOriginalListings(selectorListings);
      if (!focusedPricingGroup) {
        setFilteredListings(selectorListings);
        return;
      }

      const { selectedGroup } = store.getState().pricing;
      const { exclude_obstructed_view } = selectedGroup;
      if (!splits.length) splits.push('All');

      let filterSettings = {};
      let sectionLookup = new Set();
      if (currTNCompSections) {
        filterSettings = currTNCompSections.reduce((acc, s) => {
          if (!acc[s.canonical_name]) {
            acc[s.canonical_name] = {
              canonical_name: s.canonical_name,
              zone: s.zone_name,
              low_row: s.low_row,
              high_row: s.high_row,
              zone_type: s.zone_type,
            };
          }
          return acc;
        }, filterSettings);
        sectionLookup = new Set(
          currTNCompSections.flatMap(comp => getCanonicalName(comp.section_name, zones[marketplaceName]))
        );
      }
      const splitLookup = new Set(splits);
      const list = selectorListings.filter(listing => {
        const { section_canonical, split_vector, is_obstructed, row, quantity } = listing;

        if (isCompAll || isCompAllEvent || isCompAllGroup) {
          if (exclude_obstructed_view && is_obstructed) return false;
        } else {
          if (exclude_obstructed_view && is_obstructed) return false;
          if (!sectionLookup.has(section_canonical)) return false;
        }
        if (
          !splitLookup.has('All') &&
          !split_vector.includes('All') &&
          !split_vector.some(split => splitLookup.has(split))
        ) {
          return false;
        }
        if (split_vector.includes('All') && !splitLookup.has('All')) {
          const splitValues = Array.from(splitLookup.values());
          if (quantity < Math.min(...splitValues)) {
            return false;
          }
        }
        const currentZone = filterSettings[section_canonical];

        if (!currentZone?.low_row) return true;
        return isRowValid(row, currentZone.low_row, currentZone.high_row, currentZone.zone_type);
      });

      setFilteredListings(list);
    }
  };

  const getTotalTickets = (listings = []) => {
    const total = listings.reduce((acum, current) => {
      // eslint-disable-next-line no-param-reassign
      acum += current.quantity;
      return acum;
    }, 0);
    return total;
  };

  const handleEditMarketplaceURL = () => {
    setIsEdit(true);
  };

  const handleSplits = (event, newSplits) => {
    if (newSplits.length === 0) {
      setSplits(splits);
      return;
    }

    const hasAllSelected = newSplits.includes('All');
    let newValue = [];

    if (hasAllSelected && newSplits.length > 1 && newSplits[newSplits.length - 1] === 'All') {
      newValue = newSplits.filter(item => item === 'All');
      setSplits(newValue);
    } else if (hasAllSelected && newSplits.length > 1) {
      newValue = newSplits.filter(item => item !== 'All');
      setSplits(newValue);
    } else {
      newValue = newSplits;
      setSplits(newSplits);
    }
    handleGroupAttrEdit('splits', newValue, null)(event);
  };

  const handleTabsChange = e => {
    props.handleTabChange(e.target.value);
  };

  const onChangetEventURL = e => {
    setMarketplaceUrl(e.target.value);
  };

  const onSaveMarketplaceURL = async () => {
    setEventUrlError('');
    setIsLoading(true);
    const res = await saveEventLink(eventMeta.skybox_id, marketplaceURL, marketplaceName);
    if (res) {
      await fetchData();
      props.fetchData();
      setIsEdit(false);
    } else {
      setEventUrlError('An event could not be found with the URL you submitted. Please try again');
    }
    setIsLoading(false);
  };

  const refreshData = async () => {
    const skyboxId = eventMeta.skybox_id;
    setIsLoading(true);
    forceRefresh(skyboxId, marketplaceName);
    await fetchData();
    setRefresh();
    setIsLoading(false);
  };

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      filterListings();
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(timeoutRef.current);
  }, [activeMarketplace, focusedPricingGroup, splits, currTNCompSections, compsLoading]);

  useEffect(() => {
    if (focusedPricingGroup) {
      if (selectedGroupSplits) setSplits(selectedGroupSplits);
      else setSplits(splitsDefault);
    } else {
      setSplits(splitsDefault);
    }
  }, [selectedGroupSplits]);

  useEffect(() => {
    if (eventInfo) {
      setTimerInfo(eventInfo?.last_updated);
    }
  }, [eventInfo]);

  useEffect(() => {
    actions.setMarkeplaceFilteredListings(filteredListings ?? []);
    setTotalTickets(getTotalTickets(filteredListings));
    setTotalListings(filteredListings.length);
  }, [filteredListings]);

  const MarketplaceEvent = () => {
    return (
      <Grid item xs={3} sm={4} md={12} lg={4}>
        <Grid
          container
          style={{
            alignItems: 'center',
            justifyContent: 'flex-end',
            display: 'flex',
            marginTop: '25px',
          }}
        >
          <Grid
            item
            xs={9}
            sm={9}
            md={10}
            lg={8}
            style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
          >
            {marketURL ? (
              <a target="_blank" rel="noopener noreferrer" href={marketURL} style={{ color: '#9c27b0', fontSize: 14 }}>
                Go to event
              </a>
            ) : (
              <Typography>No Event</Typography>
            )}
          </Grid>
          <Grid
            item
            xs={3}
            sm={3}
            md={2}
            lg={4}
            style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
          >
            <Tooltip title="Edit Event" arrow placement="top" className={classes.tooltipLabel}>
              <CircleIcon onClick={handleEditMarketplaceURL}>
                <EditIcon style={{ color: 'white' }} />
              </CircleIcon>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const LastUpdatedSection = () => {
    return (
      <Grid item xs={4} sm={8} md={12} lg={8}>
        <Grid container style={{ marginTop: '25px' }}>
          <Grid
            item
            xs={10}
            md={11}
            lg={10}
            className={
              windowsSize.width < 1650 && windowsSize.width >= 960
                ? classes.lastUpdatedMedium
                : classes.lastUpdatedNormal
            }
            style={{ display: 'flex', align5183923Items: 'center' }}
          >
            <Typography style={{ fontSize: '16px' }} data-testid="last-updated-text">
              Last Updated
            </Typography>
            <Typography
              className={theme.palette.type === 'dark' ? classes.lastUpdateLabelDark : classes.lastUpdateLabelLight}
              data-testid="last-updated-time"
            >
              {updatedTimes && updatedTimes[0] ? <TimeAgo date={updatedTimes[0]} /> : <></>}
            </Typography>
          </Grid>
          <Grid item xs={2} md={1} lg={2} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Tooltip title="Refresh Data" arrow placement="top" data-testid="refresh-data-tooltip">
              <CircleIcon onClick={refreshData} data-testid="refresh-data">
                <Autorenew disabled={isLoading} style={{ color: 'white', fontSize: 'large' }} />
              </CircleIcon>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const splitsItem = (
    <Grid item xs={10} sm={10} lg={6} xl={6}>
      <FormControl component="fieldset">
        <FormLabel component="legend" style={{ paddingBottom: 5 }}>
          <Typography className={focusedPricingGroup ? '' : classes.italicLabel}>Splits</Typography>
        </FormLabel>
        <ToggleButtonGroup value={splits} onChange={handleSplits} size="small" disabled={!focusedPricingGroup}>
          {GROUP_CRITERIA_SPLITS.map(item =>
            theme.palette.type === 'dark' ? (
              <NormalStyledDarkToggleButton
                value={item.value}
                className={classes.splitButton}
                disabled={!focusedPricingGroup}
              >
                {item.label}
              </NormalStyledDarkToggleButton>
            ) : (
              <SplitStyledToggleButton
                value={item.value}
                disabled={!focusedPricingGroup}
                className={classes.splitButton}
              >
                {item.label}
              </SplitStyledToggleButton>
            )
          )}
        </ToggleButtonGroup>
      </FormControl>
    </Grid>
  );

  return (
    <Card square className={classes.pricingSection}>
      <div
        className={theme.palette.type === 'dark' ? classes.marketplaceContainerDark : classes.marketplaceContainerLight}
      >
        <ValidateUser />
        <Grid container xs={12} style={{ alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
          <Grid item xs={4} sm={4} md={6} lg={4}>
            <Grid container>
              <Grid item xs={1} sm={3} md={3} lg={3}>
                <Avatar style={{ backgroundColor: '#7D1F8D' }}>
                  <FormatListBulleted style={{ color: 'white', fontSize: 30 }} />
                </Avatar>
              </Grid>
              <Grid item xs={3} sm={9} md={9} lg={9}>
                {focusedPricingGroup ? (
                  <Grid data-testid="listings-marketplace-detail" container style={{ paddingLeft: '5px' }}>
                    <Grid item xs={12}>
                      <Typography variant="body1">Marketplace:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography color="primary" variant="body1">
                        {MARKETPLACE_LABELS[marketplaceName]}
                      </Typography>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid data-testid="listings-marketplace-select" container style={{ paddingLeft: '5px' }}>
                    <Grid item xs={12}>
                      <InputLabel shrink htmlFor="event-marketplace-select">
                        Marketplace
                      </InputLabel>
                      <Select
                        value={tabSelected}
                        onChange={handleTabsChange}
                        inputProps={{
                          name: 'marketplace',
                          id: 'event-marketplace-select',
                          'data-testid': 'change-mp-dropdown',
                        }}
                      >
                        <MenuItem value={0}>TicketNetwork</MenuItem>
                        <MenuItem value={1} data-testid="change-mp-dropdown-sg-option">
                          SeatGeek
                        </MenuItem>
                      </Select>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={8} sm={8} md={6} lg={8}>
            <Grid container>
              {windowsSize.width < 1650 && windowsSize.width >= 960 ? (
                <>
                  <LastUpdatedSection />
                  <MarketplaceEvent />
                </>
              ) : (
                <>
                  <MarketplaceEvent />
                  <LastUpdatedSection />
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Grid container className={classes.subInfoMarketplaceContainer}>
        <Grid item xs={4} md={5} xl={4}>
          <Grid
            container
            className={classes.infoListingsContainer}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item xs={6}>
              <Grid container className={classes.listingsContainer}>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <Typography style={{ fontSize: '16px' }}>Listings</Typography>
                </Grid>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <Typography data-testid="listings-listing-count" style={{ fontSize: '14px' }}>
                    <strong>{`${totalListings}/${originalListings.length}`}</strong>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid container>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <Typography style={{ fontSize: '16px' }}>Tickets</Typography>
                </Grid>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <Typography data-testid="listings-ticket-count" style={{ fontSize: '14px' }}>
                    <strong>{`${totalTickets}/${getTotalTickets(originalListings)}`}</strong>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={5} md={4} xl={6}>
          <Grid
            container
            className={classes.infoListingsContainer}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            {title === ' SeatGeek ' && realSgListingCount !== undefined && desiredSgListingCount !== undefined ? (
              <Grid item xs={12} style={{ paddingLeft: '20px' }}>
                <Grid container>
                  <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <Typography style={{ fontSize: '16px' }}>Ours</Typography>
                  </Grid>
                  <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <Typography data-testid="listings-our-tickets-count" style={{ fontSize: '14px' }}>
                      <strong>{`${realSgListingCount}/${desiredSgListingCount}`}</strong>
                      &nbsp; &nbsp; &nbsp;
                      <Hidden lgDown>
                        {realSgListingCount > desiredSgListingCount ? (
                          <strong
                            className={
                              theme.palette.type === 'dark' ? classes.OursTempLabelDark : classes.OursTempLabelLight
                            }
                            style={{ fontSize: '11px' }}
                          >
                            Temp Broadcast Delay
                          </strong>
                        ) : (
                          <></>
                        )}
                      </Hidden>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <></>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item xs={3} xl={2}>
          <Grid container className={classes.compAllContainer}>
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
              <Switch
                checked={isCompAllEvent || isCompAllGroup}
                disabled={!focusedPricingGroup}
                color="primary"
                onChange={setCompAllChange}
                classes={{
                  root: switchTheme.root,
                  switchBase: switchTheme.switchBase,
                  thumb: switchTheme.thumb,
                  track: switchTheme.track,
                  checked: switchTheme.checked,
                }}
              />
              <Typography className={classes.compAllLabel}>Comp All</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Hidden xlUp>
        {realSgListingCount >= 0 &&
        desiredSgListingCount >= 0 &&
        realSgListingCount > desiredSgListingCount &&
        title === ' SeatGeek ' ? (
          <Grid container>
            <Grid item xs={4} md={5}>
              <></>
            </Grid>
            <Grid item xs={6} md={5}>
              <Typography
                className={theme.palette.type === 'dark' ? classes.OursTempLabelDark : classes.OursTempLabelLight}
                style={{ paddingLeft: '27px', paddingBottom: '10px', marginTop: '-12px' }}
              >
                <strong>Temp Broadcast Delay</strong>
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <></>
            </Grid>
          </Grid>
        ) : (
          <></>
        )}
      </Hidden>
      <Grid container direction="row" xs={12} className={classes.splitsContainer}>
        {splitsItem}
      </Grid>
      <CardContent className={classes.cardContentRoot}>
        <div style={{ height: '100%', paddingBottom: calculatePaddingBottomListings() }}>
          {tabSelected === 0 && !eventMeta.ticketnetwork_id ? (
            <Paper square>
              <SaveEventURLContainer data-testid="save-event-url-container">
                <h3 className={classes.subTitle}>Event Not Found</h3>
                <p className={classes.eventUrlDescription}>
                  Please copy and paste the URL of the event from
                  {title}
                  below.
                </p>
                <TextField
                  error={eventUrlError}
                  style={{ width: 300 }}
                  placeholder="Event URL"
                  value={marketplaceURL}
                  onChange={onChangetEventURL}
                  helperText={eventUrlError}
                  inputProps={{ 'data-testid': 'insert-tn-url-textfield' }}
                />
                <div className={classes.eventUrlButtonContainer}>
                  <Button
                    color="default"
                    variant="contained"
                    style={{ marginRight: 20 }}
                    onClick={() => {
                      setIsEdit(false);
                    }}
                  >
                    <Typography>Cancel</Typography>
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={onSaveMarketplaceURL}
                    disabled={!marketplaceURL || isLoading}
                    data-testid="insert-tn-url-button"
                  >
                    <Typography>Save</Typography>
                  </Button>
                </div>
              </SaveEventURLContainer>
            </Paper>
          ) : (
            <div style={{ height: '100%' }}>
              {tabSelected === 1 && !eventMeta.seatgeek_id ? (
                <Paper>
                  <SaveEventURLContainer data-testid="save-event-url-container">
                    <h3 className={classes.subTitle}>Event Not Found</h3>
                    <p className={classes.eventUrlDescription}>
                      Please copy and paste the URL of the event from
                      {title}
                      below.
                    </p>
                    <TextField
                      error={eventUrlError}
                      style={{ width: 300 }}
                      placeholder="Event URL"
                      value={marketplaceURL}
                      onChange={onChangetEventURL}
                      helperText={eventUrlError}
                      inputProps={{ 'data-testid': 'insert-seatgeek-url-textfield' }}
                    />
                    <div className={classes.eventUrlButtonContainer}>
                      <Button
                        color="default"
                        variant="contained"
                        style={{ marginRight: 20 }}
                        onClick={() => {
                          setIsEdit(false);
                        }}
                        data-testid="insert-seatgeek-url-button"
                      >
                        <Typography>Cancel</Typography>
                      </Button>
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={onSaveMarketplaceURL}
                        disabled={!marketplaceURL || isLoading}
                      >
                        <Typography>Save</Typography>
                      </Button>
                    </div>
                  </SaveEventURLContainer>
                </Paper>
              ) : (
                <Paper square style={{ height: '100%' }}>
                  <div className={classes.inventoryTabsWrap}>
                    <>
                      {isEdit ? (
                        <SaveEventURLContainer data-testid="save-event-url-container">
                          <h3 className={classes.subTitle}>Edit Event</h3>
                          <p className={classes.eventUrlDescription}>
                            Please copy and paste the URL of the event from
                            {title}
                            below.
                          </p>
                          <TextField
                            error={eventUrlError}
                            style={{ width: 300 }}
                            placeholder="Event URL"
                            value={marketplaceURL}
                            onChange={onChangetEventURL}
                            helperText={eventUrlError}
                          />
                          <div className={classes.eventUrlButtonContainer}>
                            <Button
                              color="default"
                              variant="contained"
                              style={{ marginRight: 20 }}
                              onClick={() => {
                                setIsEdit(false);
                              }}
                            >
                              <Typography>Cancel</Typography>
                            </Button>
                            <Button
                              color="primary"
                              variant="contained"
                              onClick={onSaveMarketplaceURL}
                              disabled={!marketplaceURL || isLoading}
                            >
                              <Typography>Save</Typography>
                            </Button>
                          </div>
                        </SaveEventURLContainer>
                      ) : (
                        <ListingsTable listings={filteredListings} marketplace={marketplaceName} />
                      )}
                    </>
                  </div>
                </Paper>
              )}
            </div>
          )}
        </div>
        <div>
          <div className={classes.pricingLoadingModalContainer} />
        </div>
      </CardContent>
    </Card>
  );
};

Listings.defaultProps = {
  focusedPricingGroup: null,
  selectedGroupSplits: null,
};

Listings.propTypes = {
  activeMarketplace: PropTypes.string.isRequired,
  compsLoading: PropTypes.bool.isRequired,
  currTNCompSections: PropTypes.array.isRequired,
  eventInfo: PropTypes.object.isRequired,
  eventMeta: PropTypes.object.isRequired,
  focusedPricingGroup: PropTypes.any,
  actions: PropTypes.object.isRequired,
  handleGroupAttrEdit: PropTypes.func.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  isCompAllEvent: PropTypes.bool.isRequired,
  isCompAllGroup: PropTypes.bool.isRequired,
  marketsData: PropTypes.object.isRequired,
  selectedGroupSplits: PropTypes.any,
  setCompAllChange: PropTypes.func.isRequired,
  setRefresh: PropTypes.func.isRequired,
  tabSelected: PropTypes.number.isRequired,
  zones: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
  return {
    activeMarketplace: state.globals.activeMarketplace,
    compsLoading: state.refreshGroups.compsLoading,
    currTNCompSections: state.pricing.currTNComparisonSections ?? [],
    isCompAllEvent: state.groupsStubhubSeatingState.isCompAllEvent,
    selectedGroupSplits: state.pricing.selectedGroup?.splits,
    zones: state.zones,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(groupsListingsActtions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Listings);
